const pinataApiKey = "f93654008927d9e28652";
const pinataSecretApiKey = "cfc37d5e4eb2692fbc25eab823c91368e2ed2c37ecf6b5ea94c6b6685c8ca9a5";

export function uploadImagePinate(file: File) {
  return new Promise(async (resolve: (value: string) => void, reject) => {
    try {
      const files = new File([file], "image.png", { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("file", files, "image.png");
      const response = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
        method: "POST",
        headers: {
          pinata_api_key: pinataApiKey,
          pinata_secret_api_key: pinataSecretApiKey,
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const data = await response.json();
      console.log(data, "data");
      const cid = data.IpfsHash;
      resolve(`https://ipfs.io/ipfs/${cid}`);
    } catch (error) {
      reject(error);
    }
  });
}



let BASE_URL = 'https://https://upload.okduck.fun/upimg'
// const BASE_URL = 'http://localhost:8001/upload'
const fileToDataURL = (file: Blob): Promise<any> => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = (e) => resolve((e.target as FileReader).result)
    reader.readAsDataURL(file)
  })
}
const dataURLToImage = (dataURL: string): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.src = dataURL
  })
}
const canvastoFile = (canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> => {
  return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), type, quality))
}
/**
 * 图片压缩方法
 * @param {Object}  file 图片文件
 * @param {String} type 想压缩成的文件类型
 * @param {Nubmber} quality 压缩质量参数
 * @returns 压缩后的新图片
 */
export const compressionFile = async (file: File, type = 'image/jpeg', quality = 0.5) => {
  const fileName = file.name
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d') as CanvasRenderingContext2D
  const base64 = await fileToDataURL(file)
  const img = await dataURLToImage(base64)
  canvas.width = img.width
  canvas.height = img.height
  context.clearRect(0, 0, img.width, img.height)
  context.drawImage(img, 0, 0, img.width, img.height)
  const blob = (await canvastoFile(canvas, type, quality)) as Blob // quality:0.5可根据实际情况计算
  const newFile = await new File([blob], fileName, {
    type: type
  })
  return newFile
}



// export const uploadImagePinate = (selectedFile: File) => {
//   return new Promise(async (resolve: (value: string) => void, reject) => {
//     try {

//       const formdata = new FormData();
//       formdata.append("logo", selectedFile);
//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//       };
//       const res = await fetch(BASE_URL, requestOptions)
//       const resData = await res.text();
//       console.log(resData,'resData')
//       //将NFT数据转化成JSON格式存储到变量中
//       resolve(resData)
//     } catch (error) {
//       console.log(error)
//       reject(error)
//     }
//   })
// }
